
import { Button, Dialog, DialogActions, DialogContent, Grid, Menu, MenuItem, TextField, Theme, Typography } from '@material-ui/core';
import { Link, Person } from '@material-ui/icons';
import { createStyles, makeStyles } from '@material-ui/styles';
import { useContext, useRef, useState } from 'react';
import Data from '../../../../classes/Data';
import { AppContext } from '../../../../context/context';
import { ButtonRef, LoginProps, SubmitEvent } from '../../../../Interfaces/Interfaces';

const useStyle = makeStyles((theme: Theme) => createStyles({
    navbar: {
        alignSelf: 'center'
    },
}));

const Login = (props: LoginProps) => {

    const classes = useStyle();
    const { logRef } = props;
    const menuRef = useRef<ButtonRef>(null);
    const [loginAnchor, setLoginAnchor] = useState<ButtonRef>(menuRef.current);

    const { sharedData, setSharedData } = useContext(AppContext);
    const { isLogged } = sharedData;
    const [loginModal, setLoginModal] = useState(false)
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);

    const submitHandler = ((evt: SubmitEvent) => {
        evt.preventDefault();
        new Data("Users/login").POST({ username, password }).then((result:boolean) => {
            if (result) {
                const { username: currentUser } = JSON.parse(localStorage.getItem("user") as string);
                setUsername("");
                setPassword("");
                setError(false)
                setLoginModal(!loginModal)
                setSharedData({ ...sharedData, isLogged: true, username: currentUser})
            }
            else {
                setError(!error)
			}
        })
    })

    return (
        <Grid item
            innerRef={logRef}
            className={classes.navbar}
        >
            <Dialog
                open={loginModal}
                onClose={() => { setLoginModal(!loginModal) }}
            >
                <Typography style={{marginTop:20,marginBottom:20}} align="center" variant="h3" component="h2">Login</Typography>
                <DialogContent>
                    <form /*noValidate autoComplete="on"*/ onSubmit={submitHandler}>
                        <Grid container spacing={2} justify="center" alignItems="center" alignContent="center" >
                            <Grid item xs={8} style={{ display: 'flex', justifyContent: 'center' }} >
                                <TextField
                                    error={error}
                                    helperText={error && "Either Username or Password are incorrect"}
                                    onChange={(evt) => setUsername(evt.target.value)}
                                    id="username"
                                    label="Username"
                                    placeholder="Type Here"
                                    variant="outlined"
                                    value={username}
                                    autoComplete="username"
                                    />
                            </Grid>
                            <Grid item xs={8} style={{ display: 'flex', justifyContent: 'center' }}>
                                <TextField
                                    onChange={(evt) => setPassword(evt.target.value)}
                                    error={error}
                                    id="password"
                                    label="Password"
                                    placeholder="******"
                                    variant="outlined"
                                    autoComplete="current-password"
                                    value={password}
                                    type="password"
                                />
                            </Grid>
                            <Grid item xs={8} style={{ display: 'flex', justifyContent: 'center' }}>
                            {false/*showLink*/ &&
                            <Typography >Not a user? Click
                                <Typography align="center" >
                                    <Link href="#" onClick={(evt) => {
                                        evt.preventDefault()
                                        //setAppState((prevState) => ({
                                        //    ...prevState,
                                        //    modalState: {
                                        //        ...prevState.modalState,
                                        //        type: "register"
                                        //    }
                                        //}))
                                    }}>
                                        here
                                    </Link>
                                </Typography>
                            </Typography>}
                            </Grid>
                        </Grid>
                        <DialogActions>
                            <Button type="submit" color="primary" onClick={submitHandler}>
                                Login
                            </Button>
                            <Button /*onClick={handleClose}*/ color="primary">
                                Cancel
                            </Button>
                        </DialogActions>

                    </form>
                </DialogContent>
            </Dialog>
            {isLogged ?
                <>
                    <Button onClick={() => { setLoginAnchor(logRef.current) }} >
                        <Person fontSize="large" color="secondary" />
                    </Button>
                    <Menu
                        id="nav-menu"
                        anchorEl={loginAnchor}
                        open={Boolean(loginAnchor)}
                        onClick={() => { setLoginAnchor(null) }}
                    >
                        <MenuItem
                            id="logout"
                            onClick={(evt) => {
                                localStorage.removeItem('user')
                                setSharedData({...sharedData,isLogged:false,username:""})
                                setLoginAnchor(null)
                            }} >Logout</MenuItem>
                    </Menu>
                </>
                :
                <Button
                    color="secondary"
                    onClick={() => { setLoginModal(!loginModal) }/*setSharedData({ ...sharedData, isModalActive:true})}*/}
                >
                    Sign In
                </Button>
            }
        </Grid>

	)
}
export default Login ;
